import Vue from "vue";

// 滚动加载更多
Vue.directive("loadMore", {
  bind(el, binding) {
    // 获取element，定义scroll
    const select_dom = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
    select_dom.addEventListener("scroll", function () {
      // console.log("scrollHeight", this.scrollHeight);
      // console.log("scrollTop", Math.ceil(this.scrollTop));
      // console.log("clientHeight", this.clientHeight);
      // console.log("差", this.scrollHeight - Math.ceil(this.scrollTop));
      if (this.clientHeight >= this.scrollHeight - Math.ceil(this.scrollTop) - 1) {
        binding.value();
      }
    });
  }
});
